var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1303,
    height: 629,
    viewBox: "0 0 1303 629",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    id: "path-xl",
    d: "M1300.17 186.379C1307.98 225.833 1297.31 267.027 1271.29 307.749C1245.27 348.472 1203.89 388.711 1150.33 426.236C1043.21 501.286 887.382 565.454 708.233 600.94C529.085 636.426 360.56 636.506 232.919 607.958C169.098 593.683 115.51 572.255 75.9263 544.527C36.3438 516.8 10.7767 482.784 2.96172 443.331C-4.85327 403.877 5.81621 362.683 31.8403 321.961C57.8653 281.237 99.2383 240.999 152.799 203.474C259.919 128.424 415.749 64.2556 594.898 28.7697C774.046 -6.71618 942.571 -6.79582 1070.21 21.7523C1134.03 36.0264 1187.62 57.4548 1227.2 85.1827C1266.79 112.91 1292.35 146.926 1300.17 186.379Z",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXl);
export default __webpack_public_path__ + "static/media/xl.5989af4e.svg";
export { ForwardRef as ReactComponent };